import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IAppState } from '../../../state/reducers';
import { IProps, IStateProps, IDispatchProps } from './interfaces';
import ContentPreferences from './ContentPreferences/component';
import { clearContentPreferences } from '../../../state/exchange/contentPreferences';

class ExchangeContentPreferencesDialog extends React.Component<IProps> {
  render() {
    const {
      isOpen,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="xs"
      >
        <ContentPreferences />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.contentPreferences.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: clearContentPreferences,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeContentPreferencesDialog);
